// @flow
import AttributeModel from "./AttributeModel";

/**
 * Password attribute
 */
export default class CaptchaAttributeModel extends AttributeModel {
  _answer: string = "";

  /**
   */
  static isApplicableModel(contributions: Object): boolean {
    return contributions.type === "captcha";
  }

  /**
   */
  get type(): string {
    return "captcha";
  }

  /**
   * Update the attribute by name and value
   */
  update(value: string): this {
    this.updateLastModification();
    this.inputvalue = value;

    return this;
  }

  /**
   */
  setAnswer(answer: string) {
    this._answer = answer;
  }

  /**
   * Retrieve the given answer for the captcha
   * The value of this attribute is the token id of the captcha
   */
  getAnswer(): string {
    return this._answer;
  }

  /**
   */
  get hasDynamicValidationData(): boolean {
    return false;
  }
}
